import { Flex } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled(Flex)`
  padding: 16px;
  flex: 1 0 0;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  min-height: 710px;
  max-height: 710px;
  height: 100%;
  width: 100%;
`;

export const TitleWrapper = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const ContentWrapper = styled(Flex)`
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const TagsWrapper = styled(Flex)`
  width: 100%;
  max-width: 396px;
  flex-wrap: wrap;
  overflow: auto;
`;

export const Row = styled(Flex)`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  gap: 12px;
`;
